/*
 * @Author: renming-lj 2982488597@qq.com
 * @Date: 2024-05-13 17:45:58
 * @LastEditors: renming-lj 2982488597@qq.com
 * @LastEditTime: 2024-06-14 15:49:37
 * @FilePath: \program_admin\src\http\request.js
 * @Description: axios封装
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
import axios from 'axios';
import { ElMessage } from "element-plus";

const service = axios.create({
  baseURL: 'https://programserver.renlmingj.cn/',
  // baseURL: 'http://192.168.100.42:3002/',
  timeout: 5000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 添加请求头等前置处理
    let token = localStorage.getItem('token');
    if (token) {
      token = JSON.parse(token);
      config.headers['x-access-token'] = token.token;
    }
    return config
  },
  error => {
    // 请求错误处理
    console.log('Request Error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 响应后处理
    if (response.status === 200) {
      if (response.data.code === 2000) {
        return Promise.resolve({ data: response.data.data, total: response.data.total ? response.data.total : -1 });
      } else if (response.data.code === 4008) {
        ElMessage.error(response.data.msg);
        return Promise.resolve(response.data.code);
      } else if (response.data.code === 4000 || response.data.code === 4004) {
        ElMessage.error(response.data.msg);
        localStorage.removeItem('token');
        location.reload();
        return Promise.resolve(response.data.code);
      } else {
        ElMessage.error(response.data.msg);
      }
      // else if (response.data.code === 4001) {
      //   return Promise.resolve(response.data.msg);
      // } else if (response.data.code === 4002) {
      //   return Promise.resolve(response.data.msg);
      // } else if (response.data.code === 4003) {
      //   return Promise.resolve(response.data.msg);
      // }
    }
  },
  error => {
    console.log('Response Error:', error)
    return Promise.reject(error)
  }
)

export default service
